/* eslint-disable import/extensions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
const React = require('react');
const { useI18n } = require('nordic/i18n');
const { getHeadingsInfo, scrollRecoil } = require('./anchor-list.js');

const { useEffect, useState } = React;

function AnchoredMenu(props) {
  const { i18n } = useI18n();
  const { contentSelectorClass, htmlContent } = props;
  const [headings, setHeadings] = useState([]);

  useEffect(() => {
    const items = getHeadingsInfo({
      h: [2],
      maxItems: 15,
      from: contentSelectorClass,
      scrollSelector: '#dev-main',
    });

    setHeadings(items);
  }, [htmlContent]);

  if (headings.length < 2) {
    return null;
  }

  return (
    <nav className="anchored-menu anchor-mobile">
      <div className="anchored-menu-box">
        <p>{`${i18n.gettext('EN ESTA PÁGINA')}`}</p>

        <div id="anchor-container-list" className="anchored-menu-list">
          <ol className="anchor-list ">
            {headings.map(item => (
              <li className="anchor-list-item" key={item.id}>
                <a
                  onClick={scrollRecoil}
                  href={`#${item.id}`}
                  className="anchor-link"
                  title={item.label}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </nav>
  );
}

module.exports = AnchoredMenu;
